var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModal1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1817 90C70.1349 90 90.3634 69.8528 90.3634 45C90.3634 20.1472 70.1349 0 45.1817 0C20.2285 0 0 20.1472 0 45C0 69.8528 20.2285 90 45.1817 90Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9212 66.4723H21.4542C19.95 66.4723 18.7374 65.2645 18.7374 63.7664V36.3368C18.7374 34.8387 41.2758 17.4542 41.2758 17.4542C43.5495 15.5961 46.8259 15.5961 49.1112 17.4542C49.1112 17.4542 71.6496 34.8503 71.6496 36.3368V63.7664C71.6496 65.2645 70.437 66.4723 68.9328 66.4723H68.9212Z",
    fill: "#1F4DB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6377 36.3368L45.1816 48.0426L71.6377 66.4723V36.3368Z",
    fill: "#0A5DE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7373 36.3368L45.1817 48.0426L18.7373 66.4723V36.3368Z",
    fill: "#0A5DE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6378 66.4723H18.7373L39.9931 44.5704C42.7448 41.7368 47.6303 41.7368 50.382 44.5704L71.6378 66.4723Z",
    fill: "#3878FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModal1);
export default __webpack_public_path__ + "static/media/modal1.38da1c13e53e908b0cfb6d69ebc7d705.svg";
export { ForwardRef as ReactComponent };